export default {
	namespaced: true,
	state: () => ({
		activeTab: 'hot',
		categoryList: [],
		recommendList: [],
		likeList: [],
		categoryPoemList: [],
		startPlay: false,
		isChangePoem: false,
	}),
	mutations: {
		setActiveTab(state, data) {
			state.activeTab = data;
		},
		setCategoryList(state, data) {
			state.categoryList = [...data];
		},
		setRecommendList(state, data) {
			state.recommendList = [...state.recommendList, ...data];
		},
		setLikeList(state, data) {
			state.likeList = [...state.likeList, ...data];
		},
		setCategoryPoemList(state, data) {
			state.categoryPoemList = [...state.categoryPoemList, ...data];
		},
		setStartPlay(state, data) {
			state.startPlay = data;
		},
		clearRecommendList(state) {
			state.recommendList = [];
		},
		clearLikeList(state) {
			state.likeList = [];
		},
		clearCategoryPoemList(state) {
			state.categoryPoemList = [];
		},
		setIsChangePoem(state, data) {
			state.isChangePoem = data;
		},
	},
	actions: {},
	getters: {
		activeTab(state) {
			return state.activeTab;
		},
		categoryList(state) {
			return state.categoryList;
		},
		recommendList(state) {
			return state.recommendList;
		},
		likeList(state) {
			return state.likeList;
		},
		categoryPoemList(state) {
			return state.categoryPoemList;
		},
		tabListMap(state) {
			return new Map([
				['hot', state.categoryPoemList],
				['recommend', state.recommendList],
				['favorite', state.likeList],
			]);
		},
		startPlay(state) {
			return state.startPlay;
		},
		isChangePoem(state) {
			return state.isChangePoem;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/Activity/modules/poem-recitation.js